module.exports = Audio5js;


//////////////////
// WEBPACK FOOTER
// external "Audio5js"
// module id = 4V77
// module chunks = 1